export default function Error() {
	return <h3>An error occured</h3>;
}
